{
  "name": "ripeurs-operator-app",
  "version": "2.8.3",
  "description": "Operator App",
  "scripts": {
    "start": "ng serve",
    "build": "ng build"
  },
  "engines": {
    "node": "^22.22.3 || ^24.15.0 || >=26.0.0"
  },
  "private": true,
  "dependencies": {
    "@angular-devkit/core": "^22.1.3",
    "@angular/animations": "^22.1.0",
    "@angular/cdk": "^22.1.1",
    "@angular/common": "^22.1.0",
    "@angular/compiler": "^22.1.0",
    "@angular/core": "^22.1.0",
    "@angular/forms": "^22.1.0",
    "@angular/material": "^22.1.1",
    "@angular/platform-browser": "^22.1.0",
    "@angular/platform-browser-dynamic": "^22.1.0",
    "@angular/pwa": "^22.1.3",
    "@angular/router": "^22.1.0",
    "@angular/service-worker": "^22.1.0",
    "@ngx-translate/core": "^18.0.0",
    "@ngx-translate/http-loader": "^18.0.0",
    "@ripeurs/common": "3.3.54",
    "compressorjs": "^1.3.0",
    "core-js": "^3.50.0",
    "luxon": "^3.7.2",
    "node-gyp": "^13.0.1",
    "qs": "^6.15.3",
    "rxjs": "~7.8.2",
    "sass": "^1.102.0",
    "zone.js": "~0.16.2"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.1.3",
    "@angular/cli": "^22.1.3",
    "@angular/compiler-cli": "^22.1.0",
    "@angular/language-service": "^22.1.0",
    "@types/luxon": "^3.7.3",
    "@types/node": "~26.1.2",
    "@types/qs": "^6.15.1",
    "jasmine-core": "^6.3.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-jasmine": "^5.1.0",
    "ts-node": "~10.9.2",
    "tslint": "~6.1.3",
    "typescript": "~6.0.3"
  },
  "author": {
    "name": "Les Ripeurs",
    "email": "contact@lesripeurs.com",
    "url": "https://lesripeurs.com/"
  }
}
